import { render, staticRenderFns } from "./Dowjones-StarSpecial.vue?vue&type=template&id=1b9689ee&"
import script from "./Dowjones-StarSpecial.vue?vue&type=script&lang=js&"
export * from "./Dowjones-StarSpecial.vue?vue&type=script&lang=js&"
import style0 from "./Dowjones-StarSpecial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports